import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>SOL LLP</h3>
          <p>Providing compassionate and effective legal representation to families and individuals in Kelowna and throughout British Columbia.</p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/about">About Us</Link>
          <Link to="/team">Our Team</Link>
          <Link to="/family-law">Family Law</Link>
          <Link to="/personal-injury">Personal Injury</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>2314 Ellis Street, Suite 300<br />Kelowna, BC V1Y 1Z4</p>
          <p>Phone: (250) 862-1234<br />Fax: (250) 862-1235</p>
          <p>Email: info@sollawpartners.com</p>
        </div>
        <div className="footer-section">
          <h3>Office Hours</h3>
          <p>Monday - Friday: 8:30 AM - 5:00 PM<br />Saturday: By Appointment<br />Sunday: Closed</p>
          <p style={{ marginTop: '15px' }}>Emergency consultations available</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Sol LLP. All rights reserved. | Attorney Advertising</p>
      </div>
    </footer>
  );
}

export default Footer;

